// Mirrors front-office's TRADE_IN_PRODUCT route: a layer cannot import app constants, routes.nuxt.spec.ts guards the drift.
export function getTradeInModelPath({
  locale,
  category,
  slug,
}: {
  locale: string
  category: string
  slug: string
}) {
  return `/${locale.toLowerCase()}/buyback/m/${category}/${slug}`
}
